const constants = {
    ROUTING: {
        LANDING: 'landing',
        VISUALIZATION: 'visualization',
        SIMULATION: 'simulation',
        PRIVACY: 'privacy',
        TERMS: 'terms',
    },
    FEEDBACK: {
        EXPLORATION: 'exploration',
        SIMULATION: 'simulation'
    },
    COMPONENTS: {
        MONITORING: 'Monitoring',
        FORECAST: 'Forecast',
        PROJECTION: 'Projection'
    },
    PROJECTION: {
        OVERVIEW: 'overview',
        MONTH: 'month'
    },
    PERCENTILES: {
        BELOW_MEAN: 'below_mean',
        MEAN: 'mean',
        ABOVE_MEAN: 'above_mean',
    },
    SEASONS: {
        SPRING: 'spring',
        SUMMER: 'summer',
        FALL: 'fall',
        WINTER: 'winter',
    },
    STATUS: {
        TIMEOUT: 'timeout',
        UNEXPECTED: 'unexpected',
        NETWORK_ERROR: 'network_error',
        BAD_REQUEST: 'bad_request',
        UNAUTHORIZED: 'unauthorized',
        ACCESS_FORBIDDEN: 'access_forbidden',
        NOT_FOUND: 'not_found',
        SERVER_ERROR: 'server_error',
        BAD_GATEWAY: 'bad_gateway',
        NOT_AVAILABLE: 'not_available',
        PARAMS_MISSING: 'params_missing'
    },
    STORAGE: {
        SHOW_VISUALIZATION_ABOUT_STARTUP: 'show_visualization_about_startup',
        SHOW_DSS_ABOUT_STARTUP: 'show_dss_about_startup',
        SHOW_SIMULATION_STEP_INITIAL_CONDITIONS: 'show_simulation_step_initial_conditions',
        SHOW_SIMULATION_STEP_ANTHROPIC_WORKS: 'show_simulation_step_anthropic_works',
        SHOW_SIMULATION_STEP_SIMULATION_RESULTS: 'show_simulation_step_simulation_results',
    },
    SSPS: {
        SSPS1_2_6: 'ssp1-2.6',
        SSPS2_4_5: 'ssp2-4.5',
        SSPS5_8_5: 'ssp5-8.5',
    },
    STEPS: {
        MONTH: 'month',
        PRECIPITATION_TEMP: 'precipitation_temp',
        SNOW: 'snow',
        SOIL_WATER: 'soil_water'
    },
    PRECIPITATION_TEMPERATURE: {
        PRECIPITATION: 'precipitation',
        TEMPERATURE: 'temperature',
        OPTIONS: {
            PRECIPITATION_BELOW_MEAN: 'precipitation_below_mean',
            PRECIPITATION_MEAN: 'precipitation_mean',
            PRECIPITATION_ABOVE_MEAN: 'precipitation_above_mean',
            TEMPERATURE_BELOW_MEAN: 'temperature_below_mean',
            TEMPERATURE_MEAN: 'temperature_mean',
            TEMPERATURE_ABOVE_MEAN: 'temperature_above_mean',
        }
    },
    ACCORDION: {
        SIMULATION_INPUT: 'simulation_input',
        SIMULATION_RESULTS: 'simulation_results',
    },
    LAYERS: {
        MAP: 'map',
        DAM_LAKE: 'dam_lake',
        RIVER: 'river',
        DERIVATION: 'derivation',
        DERIVATION_DIRECTION: 'derivation_direction',
        DERIVATION_DIRECTION_ARROW: 'derivation_direction_arrow',
        DERIVATION_POINTS: 'derivation_points',
        PLANT: 'plant',
        AREA: 'area',
        MUNICIPALITIES: 'municipalities',
        GLACIER: 'glacier',
        RIVERS_DETAIL: 'rivers_detail',
        LAKES: 'lakes',
        AGRICULTURE_AREA: 'agriculture_area',
        VARIABLE: 'variable',

        //Raw values from external layers
        RAW_DAM_LAKE: 'Serbatoio',
        RAW_DERIVATION: 'Derivazione',
        RAW_PLANT: 'Centrale'
    },
    INFO_MODE: {
        WATER_INFRASTRUCTURE: 'water_infrastructure',
        RESULTS: 'results'
    },
    VISUALIZATION_MODE: {
        SINGLE: 'single',
        ADVANCED: 'advanced'
    },
    SIMULATION_STATUS: {
        RUNNING: 'running',
        OK: 'ok',
        STALLED: 'stalled',
    },
    MAP_OPTIONS: {
        MAP_GRAYSCALE: 'map_grayscale',
        WATER_RESOURCES: 'water_resources',
        MUNICIPALITIES: 'municipalities',
        ANTHROPIC_WORKS: 'anthropic_works',
        LAKES: 'lakes',
        AGRICULTURE_AREA: 'agriculture_area',
        GLACIER: 'glacier',
    },
    INFORMATION_OPTIONS: {
        SUMMARY: 'summary',
        GLOSSARY: 'glossary'
    },
    LABELS: {
        NO_LABEL: 'no_label',
    }
}

export default constants;